<button mat-button data-test="buttons-time" class="answer__button closecare-button primary-bg" (click)="openDialogHour()">{{answer?.button.label}}</button>